import { datoCMSMaterialIcons } from '@/utils/icons';
import type { IconHeadingFragment } from '@/utils/dato/generated';

const IconHeading = ({ heading, icon }: IconHeadingFragment) => (
  <div className="flex items-center gap-7">
    {icon && datoCMSMaterialIcons?.[icon] ? (
      <span
        className={`${icon === 'exclamation' ? 'text-warning-content' : 'text-success-content'} 
        material-symbols-outlined !text-6xl`}
      >
        {datoCMSMaterialIcons[icon]}
      </span>
    ) : null}
    {heading ? <h3 className="pt-2 text-2xl lg:text-3xl font-serif font-semibold">{heading}</h3> : null}
  </div>
);

export default IconHeading;
